
// region JS Imports

// region External Modules
import u from "umbrellajs"
import Promise from "plugins/bluebird"
// endregion External Modules

// Private Modules
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
import {
  Factory,
  ListingCarousel,
  InputSelector as ListingCarouselInputSelector,
} from "./factory"
import Photoswipe_Factory from "./photoswipe/factory"
import Swiper_Factory from "components/swiper"
import StaticMap from "./map_view/index"

// endregion Private Components

// endregion JS Imports

const CELL_LISTING_CAROUSEL_DEFAULT = "cell-listing-carousel"
const CELL_INITIALIZED_CLASS_NAME = `${CELL_LISTING_CAROUSEL_DEFAULT}--js-spacious-initialized`

const CELL_LISTING_CAROUSEL_WITH_SWIPE = "cell-listing-carousel-with-swiper"
const CELL_WITH_SWIPE_INITIALIZED_CLASS_NAME = `${CELL_LISTING_CAROUSEL_WITH_SWIPE}--js-spacious-initialized`

const CELL_LISTING_CAROUSEL_MAP_VIEW = "cell-listing-carousel-map-view"
const CELL_MAP_VIEW_INITIALIZED_CLASS_NAME = `${CELL_LISTING_CAROUSEL_MAP_VIEW}--js-spacious-initialized`

const LISTING_CAROUSELS = [] as ListingCarousel[]


function init_one_element_with_promise(options: {
  container_element: Element,
  listing_carousel_selector?: ListingCarouselInputSelector,
  disable_init_protection?: true,
}): Promise<void> {
  // region inputs

  const container_element = options.container_element
  const listing_carousel_selector: ListingCarouselInputSelector = options.listing_carousel_selector || {}
  const disable_init_protection = options?.disable_init_protection || false
  const enable_init_protection = !disable_init_protection

  // endregion inputs

  if (enable_init_protection && container_element.classList.contains(CELL_INITIALIZED_CLASS_NAME)) {
    return Promise.resolve()
  }
  container_element.classList.add(CELL_INITIALIZED_CLASS_NAME)

  LISTING_CAROUSELS.push(
    Factory.create(
      container_element,
      listing_carousel_selector,
    ),
  )
  Photoswipe_Factory.create(container_element, {})
  return Promise.resolve()
}

function init_one_swiper_element_with_promise(options: {
  container_element: Element,
  listing_carousel_selector?: ListingCarouselInputSelector,
  disable_init_protection?: true,
}): Promise<void> {
  // region inputs

  const container_element = options.container_element
  const listing_carousel_selector: ListingCarouselInputSelector = options.listing_carousel_selector || {}
  const disable_init_protection = options?.disable_init_protection || false
  const enable_init_protection = !disable_init_protection

  // endregion inputs

  if (enable_init_protection && container_element.classList.contains(CELL_WITH_SWIPE_INITIALIZED_CLASS_NAME)) {
    return Promise.resolve()
  }
  container_element.classList.add(CELL_WITH_SWIPE_INITIALIZED_CLASS_NAME)

  LISTING_CAROUSELS.push(
    Factory.create(
      container_element,
      listing_carousel_selector,
    ),
  )

  // Slow, do it async
  return new Promise((resolve) => {
    // https://swiperjs.com/swiper-api
    Swiper_Factory.create(container_element, {})
    resolve()
  })
}

const init = () => {
  u(`.${CELL_LISTING_CAROUSEL_DEFAULT}`).each((el) => {
    init_one_element_with_promise({
      container_element: el,
    }).done()
  })

  u(`.${CELL_LISTING_CAROUSEL_WITH_SWIPE}`).each((el) => {
    // Very slow, splitting tasks into smaller async tasks
    setTimeout(() => {
      init_one_swiper_element_with_promise({
        container_element: el,
      })
    })
  })

  u(`.${CELL_LISTING_CAROUSEL_MAP_VIEW}`).each((el) => {
    if (el.classList.contains(CELL_MAP_VIEW_INITIALIZED_CLASS_NAME)) { return }
    el.classList.add(CELL_MAP_VIEW_INITIALIZED_CLASS_NAME)

    StaticMap.init({
      main: el,
    })
  })
}

function startCycling(): void {
  LISTING_CAROUSELS.forEach((carousel) => {
    carousel.cycle()
  })
}

export default {
  init,
  init_one_element_with_promise,
  startCycling,
}
